import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import classnames from 'classnames'
import moment from 'moment'
import numeral from 'numeral'
import { pathNameKeygen } from '../../actions'
import BetsList from './BetsList'
import RecommendationsList from './RecommendationsList'
import { smallTableBetsColumns } from '../../settings'
import { getRecommendationsPath } from '../../util'
import './Recommendations.css'

import get from 'lodash/get'
import forEach from 'lodash/forEach'
import range from 'lodash/range'
import keys from 'lodash/keys'


const TEST_SET_START_DATE = moment('2017-01-30')
const MIN_BAR_HEIGHT = 10

class RecommendationsPage extends React.Component {
  _selectDay = (date) => {
    const { playerId } = this.props
    browserHistory.push(getRecommendationsPath(playerId, date))
  }

  _renderBetsPerDay() {
    const { player } = this.props

    const betsPerDay = {}
    let maxCount = 0
    let minDate = null
    let maxDate = null

    get(player, 'bets_per_day', [])
      .forEach(item => {
        const day = moment(item.day)
        betsPerDay[day.format('YYYY-MM-DD')] = {
          count: item.count,
          name: day.format('ddd DD-MM-YYYY'),
          day,
          isTest: day.isAfter(TEST_SET_START_DATE)
        }

        if(item.count > maxCount) { maxCount = item.count }
        if(!minDate || day.diff(minDate) < 0) { minDate = day }
        if(!maxDate || day.diff(maxDate) > 0) { maxDate = day }
      })

    if(!minDate || !maxDate) { return }

    const totalDays = maxDate.diff(minDate, 'days')
    const ret = []
    forEach(range(totalDays + 1), () => {
      const key = minDate.format('YYYY-MM-DD')
      const item = betsPerDay[key]
      const height = item ? Math.max(MIN_BAR_HEIGHT, (item.count / maxCount) * 100.0) + '%': '0%'

      ret.push(
        <div className="bar-wrapper" key={key} onClick={this._selectDay.bind(this, moment.utc(key))}>
          <div
            className={classnames('bar', {'bar--test': item && item.isTest})}
            style={{height}}
          >
          </div>

          <div className="bar__info">
            <div>{minDate.format('ddd DD-MM-YYYY')}</div>
            <div>{item ? item.count : 0} bets</div>
          </div>
        </div>
      )

      minDate.add(1, 'days')
    })

    return ret

    // .sort((obj1, obj2) => obj1.day.diff(obj2.day, 'days'))
  }

  render() {
    const { date, hits, totalBets } = this.props;

    const totalHits = keys(hits).length;
    let recall = 0;

    if(totalBets > 0) {
      recall = totalHits / totalBets;
    }

    return (
      <div className="recommendations-page">
        <div className="tickets-per-day-container">
          <h2>Bets per day</h2>

          <div className="bars-container">
            { this._renderBetsPerDay()}
          </div>
        </div>

        <div className="hbox hbox--vtop">
          <div className="bet-list hbox--flex">
            <h3 className="table-title">
              User bets on events
              <span className="table-title__hint">from {date.format('ddd DD-MM-YYYY HH:mm:ss')}</span>
            </h3>
            <BetsList 
              {...this.props}
              columns={smallTableBetsColumns}
              beginGt={date.format('YYYY-MM-DD 00:00:00')}
              beginLt={moment(date).add(1, 'day').format('YYYY-MM-DD 00:00:00')} />
          </div>
          <div className="bet-list hbox--flex">
            <h3 className="table-title">
              System would recommend
              <span className="table-title__hint">
                hit {totalHits} of {totalBets} {numeral(recall).format('0.00%')} recall
              </span>
            </h3>
            <RecommendationsList 
              {...this.props} 
              keygen={pathNameKeygen}
              afterDate={date.format('YYYY-MM-DDTHH:mm:ss')}
              beforeDate={moment(date).add(1, 'day').format('YYYY-MM-DDT00:00:00')} />
          </div>
        </div>
      </div>
    )
  }
}

const calculateHits = function(state, bets, recommendations) {
  if(!bets || !recommendations) { return {} }

  const betEventIds = {}
  forEach(bets.pages, (page, index) => {
    forEach(page.ids, id => {
      betEventIds[state.entities.bets[id].event_id] = true
    })
  })

  const hits = {}
  forEach(recommendations.pages, (page, index) => {
    forEach(page.ids, id => {
      // bet recommendation id is the event id
      if(betEventIds[id]) {
        hits[id] = true
      }
    })
  })

  return { hits, betEventIds }
}

export const Recommendations = connect(
  (state, ownProps) => {
    const { playerId } = ownProps.params
    const { date } = ownProps.location.query
    const key = pathNameKeygen({state, ownProps})

    const bets = get(state, ['pagination', 'bets', key])
    const recommendations = get(state, ['pagination', 'betRecommendations', key])
    const { hits, betEventIds } = calculateHits(state, bets, recommendations)

    return {
      playerId: playerId,
      player: state.entities.players[playerId],
      date: moment(date).utc(),
      location: ownProps.location,
      hits,
      totalBets: keys(betEventIds).length
    }
  },
  { }
)(RecommendationsPage)

// <h2 className="page-title hbox hbox--vcenter">
//   <span>Showing recommendations for events played from </span>
//   <input 
//     className={classnames("date-time-input after-date", {'is-dirty': afterDateDirty})} 
//     type="datetime-local" 
//     value={afterDate.format('YYYY-MM-DDTHH:mm')}
//     onChange={this._hanldeDateChange.bind(this, 'after')}
//     onKeyDown={this._handleDateKeyDown.bind(this, 'after')}
//   /> 
//   <span className="date-input-sep">to</span>
//   <input 
//     className={classnames("date-time-input after-date", {'date-time-input--dirty': beforeDateDirty})} 
//     type="datetime-local" 
//     value={beforeDate.format('YYYY-MM-DDTHH:mm')}
//     onChange={this._hanldeDateChange.bind(this, 'before')}
//     onKeyDown={this._handleDateKeyDown.bind(this, 'before')}
//   />
// </h2>

// <div className="page-subtitle">
//   Recommendations are calculated using betting history before {afterDate.format('DD/MM/YYYY HH:mm a')}
// </div>


// WEBPACK FOOTER //
// ./src/components/Players/Recommendations.js